import styled from '@emotion/styled'
import { ButtonBase } from '@mui/material'
import { colors, fontSize, size } from '@styles/theme'
import { PiArrowLeftBold, PiSpinnerBold } from 'react-icons/pi'
import { TbTrash } from 'react-icons/tb'
import { drawerDimensions } from './UserMediaDrawer'
import YesOrNo from '@elements/YesOrNo'
import useYesOrNo from '@hooks/useYesOrNo'

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  padding-bottom: ${size(1)};
`

const CloseButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: ${fontSize('sm')};
  height: ${size(4)};
  padding: 0 ${size(1.25)};
  background-color: #333333;
  border-radius: 100px;
`

const TrashButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  height: ${size(4)};
  width: ${size(4)};
  background-color: ${colors.statusColors.right_now('primary')};
  border-radius: 100px;
  svg {
    filter: drop-shadow(0 1px 2px #333333CC);
  }
`

const DisplayMessage = styled.h3`
  font-size: ${fontSize('lg')};
  margin: 0;
  padding: 0;
`

const LoadingText = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;

  padding-left: ${size(1.5)};
  padding-right: ${size(1.5)};
  
  font-weight: 600;
  font-size: ${fontSize('sm')};
`

const MediaDrawerHeader = ({ setClosed, isMediaSelected, hasMedia, drawerDimensions, deleteMedia, isLoading, isLoadingDelayed }) => {
  const [isYesNoOpen, openYesNo, closeYesNo] = useYesOrNo('confirm-delete-user-media')

  const handleYesNoSelect = (yesOrNo) => {
    if(yesOrNo) deleteMedia()
    closeYesNo()
  }

  const renderDisplayMessage = () => {
    if (hasMedia) {
      return (
        <DisplayMessage>
          Select Media
        </DisplayMessage>
      )
    } else {
      return (
        <DisplayMessage>
          Upload Media
        </DisplayMessage>
      )
    }
  }

  const renderLoadingText = () => {
    return (
      <LoadingText>
        <PiSpinnerBold
          className='animation_rotation'
          strokeWidth={size(1.5)}
        />
        &nbsp;Loading
      </LoadingText>
    )
  }

  return (
    <DrawerHeader style={{ height: drawerDimensions?.drawerHeaderHeight }}>
      <YesOrNo
        isOpen={isYesNoOpen}
        setClosed={closeYesNo}
        handleSelect={handleYesNoSelect}
        title='Delete Media'
        body='Delete the current media selected?'
      />
      <CloseButton onClick={setClosed}>
        <PiArrowLeftBold />
        &nbsp;Back&nbsp;
      </CloseButton>
      {isLoadingDelayed && renderLoadingText()}
      {isMediaSelected
        ? (
          <TrashButton
            disabled={isLoading}
            onClick={openYesNo}>
            <TbTrash size={size(2.25)} />
          </TrashButton>
        )
        : renderDisplayMessage()
      }
    </DrawerHeader>
  )
}

export { MediaDrawerHeader }
